// extracted by mini-css-extract-plugin
module.exports = {"root":"CardIconButton_root__1EGol"};